<template>
  <div>
    <h3 class="display-4" @click="enableDebug($event)">Manage Supervisors</h3>

    <o-list-toolbar
      :filters-list="filter_list"
      :search-fields-list="search_field_list"
      :selected-filter="selected_filter"
      :list-options="list_options"
      @reset_table="reset_table"
      @options_changed="update_table($event)"
      @filter_changed="update_filter($event)"
      :schema="schema"
      :query-select-options="options"
      :new-to="{ name: 'supervisor.create', params: { id: 0 } }"
      new-button-text="New Supervisor"
    >
    </o-list-toolbar>

    <b-table
      striped
      bordered
      :fields="fields"
      :items="items"
      head-variant="light"
      class="o-list"
      thead-class="o-gradient-header"
      no-local-sorting
      @sort-changed="change_sort"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order == 'desc'"
    >
      <template slot="cell(description)" slot-scope="{ index, item }">
        <router-link :to="{ name: 'supervisor.edit', params: { id: item.id } }">
          <default-display :value="item.description"></default-display>
        </router-link>
      </template>
      <template slot="cell(code)" slot-scope="{ index, item }">
        <default-display :value="item.code"></default-display>
      </template>
      <template slot="cell(customer)" slot-scope="{ index, item }">
        <lookup-display
          :list="optionCustomerItemsById"
          :value="item.customer"
          display-field="name"
          default-value="-"
        ></lookup-display>
      </template>
      <template slot="cell(active_start_date)" slot-scope="{ index, item }">
        <date-display
          :value="item.active_start_date"
          format="DD/MM/YYYY hh:mm"
        ></date-display>
      </template>
      <template slot="cell(active_end_date)" slot-scope="{ index, item }">
        <date-display
          :value="item.active_end_date"
          format="DD/MM/YYYY hh:mm"
        ></date-display>
      </template>

      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'supervisor.create' }"
          >create a new item</router-link
        >
      </template>
    </b-table>

    <o-list-paging
      :limit="list_options.limit"
      :page-options="rows_per_page_items"
      :offset="list_options.offset"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>

<style></style>

<script>
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
} from "../../../vue-ocom/mixins";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import schema from "../../schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar";
import OListPaging from "../../../vue-ocom/components/list/OListPaging";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";

export default {
  components: {
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
  },
  mixins: [
    CreateListPageMixin("Supervisor", "supervisor"),
    CreateGroupPermissionMixin("Supervisor"),
    CreateCodeTableFetchMixin(["Customer"]),
  ],
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.Supervisor,
        {}
      ) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.Supervisor),

      filter_list: [
        { name: "Active", code: "active", options: { offset: 0, sort: "id" } },
        {
          name: "Non Active",
          code: "inactive",
          options: { offset: 0, sort: "id" },
        },
        { name: "All", code: "all", options: { offset: 0, sort: "id" } },
      ],
    };
  },
  computed: {
    options() {
      return {
        Customer: {
          options: this.optionCustomerItems,
          textField: "name",
          valueField: "id",
        },
      };
    },
    fields() {
      return this.filterTableColumns(this.schema, [
        fieldToTableColumn(this.schema, "description"),
        fieldToTableColumn(this.schema, "code"),
        fieldToTableColumn(this.schema, "customer"),
        fieldToTableColumn(this.schema, "active_start_date"),
        fieldToTableColumn(this.schema, "active_end_date"),
      ]);
    },
  },
};
</script>
